<template>
  <lateral-modal
    :title="$t('budgets_new_budget_header')"
    @close="closeModal"
  >
    <template slot="content">
      <form
        class="Form px-2"
        id="budget-form"
        @submit.prevent="submitBudget"
      >
        <div
          class="row"
          v-if="!budgetEditFlag"
        >
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label u-required"> {{$t('budgets_new_budget_budget_name').toUpperCase()}}</label>
              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.budget.name.$error}"
                v-focus-input
              >
                <input
                  class="Input-text"
                  type="text"
                  @blur="$v.budget.name.$touch()"
                  v-model="budget.name"
                  :placeholder="$t('budgets_new_budget_budget_name')"
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="!budgetEditFlag"
        >
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label u-required">{{$t('budgets_new_budget_budget_limit').toUpperCase()}}</label>

              <div
                class="Form-field required"
                :class="{'Form--field-error' : $v.budget.goal.$error}"
                v-focus-input
              >
                <currency-input
                  :class="'Input-text'"
                  v-model="budget.goal"
                  :allow-negative="false"
                  @blur="$v.budget.goal.$touch()"
                ></currency-input>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="!budgetEditFlag"
        >
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label
                for="budget-cycle-selector"
                class="form--label u-required"
              >{{$t('budgets_budget_cycle_selector').toUpperCase()}}</label>
              <div class="multiselect-filter multiselect-tags">
                <multiselect
                  :options="budgetCycles"
                  id="'budget-cycle-selector'"
                  track-by="id"
                  :showLabels="false"
                  :customLabel="generateBudgetCycleLabel"
                  :placeholder="$t('MULTISELECT_DEFAULT_SELECT_LABEL')"
                  v-model="budget.budgetCycle"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                  <template v-slot:noOptions>
                    <span>{{$t('multiselect_no_options_slot_default')}}</span>
                  </template>
                  <template v-slot:noResult>
                    <span>{{$t('MULTISELECT_DEFAULT_NO_RESULTS')}}</span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 pl-2 pr-2">
            <p class="p p--tip">
              {{budgetCycleInfoLabel}}
            </p>
          </div>
        </div>
        <div
          class="row"
          v-if="!budgetEditFlag"
        >
          <div class="col-12">

            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label"> {{$t('budgets_new_budget_expiration').toUpperCase()}}</label>

              <date-picker-input
                :mode="'single'"
                :placeholder="'date_picker_input_expiration_date_select_default_date'"
                :minDate="new Date()"
                @inputDate="setBudgetExpirationDate"
              ></date-picker-input>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input--block h-100 input--block--margin input--block--padded">
              <label class="form--label u-required">{{$t('budgets_new_budget_owners').toUpperCase()}}</label>
              <multi-select-custom
                v-model="owners"
                :options="usersForBudgets"
                :placeholder="$t('user_finder_selector_type_to_find')"
                :label="usersForBudgetsLabel"
                @setSelectedItems="setUsers('owners', $event)"
                @removeItem="removeUser('owners',$event)"
                @open="checkOwnerLengthInvalid"
                @close="checkOwnerLengthInvalid"
                :classList="ownersLengthInvalidFlag? 'multiselect--error' : ''"
              ></multi-select-custom>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input--block h-100 input--block--margin input--block--padded">
              <label class="form--label"> {{$t('budgets_new_budget_members').toUpperCase()}}</label>
              <multi-select-custom
                v-model="members"
                :closeOnSelect="false"
                :options="usersForBudgets"
                :label="usersForBudgetsLabel"
                :placeholder="$t('user_finder_selector_type_to_find')"
                @setSelectedItems="setUsers('members', $event)"
                @removeItem="removeUser('members',$event)"
              ></multi-select-custom>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="!budgetEditFlag"
        >
          <div class="col-12">
            <div class="input--block input--block--margin input--block--padded">
              <label class="form--label"> {{$t('budgets_new_budget_review_flow').toUpperCase()}}</label>
              <div class="multiselect-custom-field multiselect-tags">
                <multiselect
                  :options="reviewFlowOptions"
                  id="'budget-cycle-selector'"
                  track-by="id"
                  :showLabels="false"
                  :label="'name'"
                  :placeholder="$t('MULTISELECT_DEFAULT_SELECT_LABEL')"
                  v-model="budget.flow"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                  <template
                    slot="singleLabel"
                    slot-scope="{ option } "
                  >
                    <span class="d-flex">
                      {{option.name}}

                      <span
                        class="icon-info ml-2"
                        v-if="option.code === 'FUELL_DEFAULT_FLOW'"
                      >
                        <info-display
                          :class="'icon-info'"
                          :infoText="$t('budgets_new_budget_review_flow_default_flow_info')"
                        />
                      </span>
                    </span>
                  </template>
                  <template v-slot:noOptions>
                    <span>{{$t('multiselect_no_options_slot_default')}}</span>
                  </template>
                  <template v-slot:noResult>
                    <span>{{$t('MULTISELECT_DEFAULT_NO_RESULTS')}}</span>
                  </template>

                </multiselect>
              </div>

            </div>

          </div>
        </div>
        <div v-if="officeFeatureBudgetFields">
          <div
            class="row"
            v-if="!budgetEditFlag"
          >
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField1Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budget.budgetField1"
                    :placeholder="$t('export_fields_budgetField1Label')"
                  >
                </div>
              </div>

            </div>
          </div>
          <div
            class="row"
            v-if="!budgetEditFlag"
          >
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField2Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budget.budgetField2"
                    :placeholder="$t('export_fields_budgetField2Label')"
                  >
                </div>
              </div>

            </div>
          </div>
          <div
            class="row"
            v-if="!budgetEditFlag"
          >
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label class="form--label"> {{$t('export_fields_budgetField3Label').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  v-focus-input
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="budget.budgetField3"
                    :placeholder="$t('export_fields_budgetField3Label')"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        v-if="!budgetEditFlag"
        class="Fuell-Button block blue"
        type="submit"
        form="budget-form"
        :disabled="!canBeSubmitted  || owners.length === 0 || isSubmitting || usersForBudgets.length === 0"
        v-t.preserve="{path:'ACTION_CREATE'}"
      ></button>
      <button
        class="Fuell-Button block blue"
        @click="updateBudget"
        :disabled="!canBeSubmitted  || owners.length === 0 || isSubmitting || usersForBudgets.length === 0"
        v-t.preserve="{path:'ACTION_UPDATE'}"
        v-else
      >
      </button>
    </template>
  </lateral-modal>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import DatePickerInput from '@/components/Commons/Forms/DatePickerInput'
import Multiselect from 'vue-multiselect'
import MultiSelectCustom from '@/components/Commons/Forms/MultiSelectCustom'
import InfoDisplay from '@/components/Commons/InfoDisplay'
import { CurrencyInput } from 'vue-currency-input'
import { segmentTrack } from '@/analytics/segment'
import LateralModal from '@/components/Commons/Modals/LateralModal'
const { validationMixin } = require('vuelidate')
const { required, minValue } = require('vuelidate/lib/validators')
export default {
  name: 'CreateBudgetModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: { DatePickerInput, CurrencyInput, Multiselect, InfoDisplay, MultiSelectCustom, LateralModal },
  props: {
    budgetForUserChange: {
      type: Object
    }
  },
  data () {
    return {
      owners: [],
      ownersLengthInvalidFlag: false,
      members: [],
      isSubmitting: false,
      budget: {
        name: '',
        goal: 0,
        budgetCycle: '',
        expirationDate: '',
        userBudgets: [],
        flow: null

      },
      usersForBudgetsLabel: ['firstName', 'lastName'],
      budgetEditFlag: false,
      originalBudgetOwners: [],
      originalBudgetMembers: []
    }
  },
  methods: {
    generateBudgetCycleLabel ({ code }) {
      return this.$t(`budgets_budget_type__${code}`)
    },
    setBudgetCycle (cycleType) {
      if (!cycleType) return
      cycleType === 'monthly' ? this.budget.budgetCycle.id = 1 : this.budget.budgetCycle.id = 2
    },
    setBudgetExpirationDate (event) {
      this.budget.expirationDate = event
    },
    setUsers (role, event) {
      const { email } = event

      if (email) {
        delete event.email
      }
      this[role].push(event)

      if (role === 'owners') {
        this.checkOwnerLengthInvalid()
      }
    },
    removeUser (role, event) {
      if (role === 'owners') {
        const userIsMemberIndex = this.members.findIndex(el => el.id === event.id)
        if (userIsMemberIndex > -1) {
          this.members[userIsMemberIndex].isOwner = false
        }
      } else {
        const userIsOwnerIndex = this.owners.findIndex(el => el.id === event.id)
        if (userIsOwnerIndex > -1) {
          this.owners[userIsOwnerIndex].isMember = false
        }
      }

      this[role] = [...this[role].filter(el => el.id !== event.id)]
    },
    checkOwnerLengthInvalid () {
      if (this.owners.length === 0) {
        this.ownersLengthInvalidFlag = true
      } else {
        this.ownersLengthInvalidFlag = false
      }
    },
    generateUserBudgets () {
      let userBudgets = []

      this.owners.forEach(el => {
        const owner = { ...el }
        owner.isOwner = true
        owner.isMember = false
        owner.user = { id: owner.id }

        userBudgets.push(owner)
      })

      this.members.forEach(el => {
        const member = { ...el }
        const alreadyInUserBudgets = userBudgets.findIndex(el => el.id === member.id)

        if (alreadyInUserBudgets > -1) {
          userBudgets[alreadyInUserBudgets].isMember = true
        } else {
          member.isMember = true
          member.user = { id: member.id }
          userBudgets.push(member)
        }
      })
      userBudgets = userBudgets.map(el => {
        const item = { ...el }
        delete item.id
        return item
      })
      return userBudgets
    },
    async submitBudget () {
      if (this.isCallingBudgets) return
      this.budget.userBudgets = this.generateUserBudgets()
      if (!this.budget.expirationDate) {
        delete this.budget.expirationDate
      }
      const owners = this.budget.userBudgets.filter(el => el.isOwner).length
      const members = this.budget.userBudgets.filter(el => !el.isOwner).length
      await this.$store.dispatch('BudgetsStore/createBudget', this.budget)
      const createdBudgetTraits = {
        budget_name: this.budget.name,
        budget_limit: this.budget.goal,
        frequency: this.budget.budgetCycle.id === 1 ? 'monthly' : 'one-time',
        expiration: this.budget.expirationDate ? this.$moment.utc(this.budget.expirationDate).format('DD-MM-YYYY hh:mm:ss') : '',
        owners: owners,
        members: members,
        group_id: this.$store.getters['LoginStore/user'].customer_id
      }
      segmentTrack('Budget created', createdBudgetTraits)
      this.closeModal()
    },
    async updateBudget () {
      if (this.isSubmitting) return
      this.isSubmitting = true
      const originalOwners = this.budgetForUserChange.userBudgets.filter(el => el.isOwner).length
      const originalMembers = this.budgetForUserChange.userBudgets.filter(el => !el.isOwner).length
      const budgetUpdated = {
        userBudgets: this.generateUserBudgets()
      }

      await this.$store.dispatch('BudgetsStore/updateBudget', { budgetId: this.budgetForUserChange.id, budgetUpdateInformation: budgetUpdated, trackBudgetUserChanges: true })

      const updateMembers = budgetUpdated.userBudgets.filter(el => !el.isOwner).length
      const updateOwners = budgetUpdated.userBudgets.filter(el => el.isOwner).length
      if (originalMembers !== updateMembers) {
        segmentTrack('Budget members changed', {
          budget_member_count: updateMembers
        })
      }
      if (originalOwners !== updateOwners) {
        segmentTrack('Budget owners changed', {
          budget_owner_count: updateOwners
        })
      }
      this.isSubmitting = false
      this.closeModal()
    },
    _initialize () {
      this.budget.budgetCycle = this.budgetForUserChange.budgetCycle
      this.budget.expirationDate = this.budgetForUserChange.expirationDate
      this.budget.goal = this.budgetForUserChange.goal
      this.budget.name = this.budgetForUserChange.name

      const budgetOwners = this.budgetForUserChange.userBudgets.filter(el => el.isOwner)
      if (budgetOwners.length > 0) {
        this.owners = budgetOwners.map(el => { return { id: el.user.id, firstName: el.user.firstName, lastName: el.user.lastName, isOwner: el.isOwner, isMember: el.isMember } })

        this.originalBudgetOwners = [...this.owners]
      }
      const budgetMembers = this.budgetForUserChange.userBudgets.filter(el => el.isMember)
      if (budgetMembers.length > 0) {
        this.members = budgetMembers.map(el => { return { id: el.user.id, firstName: el.user.firstName, lastName: el.user.lastName, isOwner: el.isOwner, isMember: el.isMember } })
        this.originalBudgetMembers = [...this.members]
      }
      this.budgetEditFlag = true
    }
  },
  computed: {
    officeFeatureBudgetFields () {
      return this.$store.getters['CompanyStore/currentCompany']?.activatedFeatures?.find(item => item.feature.code === 'SHOW_BUDGET_FIELDS')
    },
    usersForBudgets () {
      return this.$store.getters['UsersStore/users'] || []
    },
    budgetCycleInfoLabel () {
      if (this.budget && this.budget.budgetCycle && this.budget.budgetCycle.code) {
        return this.$t(`budgets_budget_type__${this.budget.budgetCycle.code}_info`)
      }
      return ''
    },
    isCallingBudgets () {
      return this.$store.getters['BudgetsStore/isCallingBudgets']
    },
    canBeSubmitted () {
      // TODO: Fix dirty check
      return !this.$v.$invalid // && this.hasChangedUsers
    },
    officeId () {
      if (this.$store.getters['CompanyStore/currentCompany'] && this.$store.getters['CompanyStore/currentCompany'].id) {
        return this.$store.getters['CompanyStore/currentCompany'].id
      } else {
        return this.$store.getters['LoginStore/user'].office_id
      }
    },
    hasChangedUsers () {
      const hasChangesInOwners = JSON.stringify(this.originalBudgetOwners) !== JSON.stringify(this.owners)
      const hasChangesInMembers = JSON.stringify(this.originalBudgetMembers) !== JSON.stringify(this.members)
      return hasChangesInOwners || hasChangesInMembers
    },
    budgetCycles () {
      return this.$store.getters['ConfigStore/privateConfig'].budget_cycle || []
    },
    reviewFlows () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlows'] || []
    },
    fakeDefaultFlow () {
      return {

        id: 'default',
        name: this.$i18n.t('budgets_new_budget_fuell_default_review_flow'),
        code: 'FUELL_DEFAULT_FLOW'

      }
    },
    reviewFlowOptions () {
      return [this.fakeDefaultFlow, ...this.reviewFlows]
    },
    defaultReviewFlow () {
      return this.reviewFlows.find(el => el.byDefault) || false
    }

  },
  async created () {
    if (this.budgetForUserChange) {
      this._initialize()
    }
    this.$store.dispatch('UsersStore/clearUserList')
    this.$store.dispatch('UsersStore/fetchUsersForBudgets', this.officeId)

    if (this.reviewFlows.length === 0) {
      await this.$store.dispatch('CompanyStore/TransactionFieldsStore/fetchReviewFlows')
    }
    this.defaultReviewFlow ? this.budget.flow = this.defaultReviewFlow : this.budget.flow = this.fakeDefaultFlow
  },
  validations: {
    budget: {
      name: { required },
      goal: { required, minValue: minValue(1) },
      budgetCycle: { required }
    }
  }

}
</script>

<style scoped>
.Tabs-itmLink {
  text-decoration: none;
}
</style>
<style>
.multiselect--error {
  border: 2px solid red;
  border-radius: 6px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
